import { render, staticRenderFns } from "./mv.vue?vue&type=template&id=f1704a2a&scoped=true&"
import script from "./mv.vue?vue&type=script&lang=js&"
export * from "./mv.vue?vue&type=script&lang=js&"
import style0 from "./mv.vue?vue&type=style&index=0&id=f1704a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1704a2a",
  null
  
)

export default component.exports